LÖytyy<template>
  <mdb-container fluid class="mt-3">
    <h4>AI-hakuanalytiikka</h4>

    <!-- Aikavälisuodatin -->
    <div class="d-flex align-items-center mb-3 gap-2">
      <label class="me-2 mb-0">Aikaväli:</label>
      <mdb-btn
        v-for="d in [7, 30, 90]"
        :key="d"
        size="sm"
        :color="days === d ? 'primary' : 'secondary'"
        outline
        @click.native="setDays(d)"
        >{{ d }} pv</mdb-btn
      >
    </div>
    <!-- KPI-kortit -->
    <mdb-row class="mb-4" v-if="summary">
      <mdb-col md="2" v-for="kpi in kpiCards" :key="kpi.label">
        <div class="card shadow-sm h-100 py-2" :class="kpi.borderClass">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-uppercase mb-1" :class="kpi.textClass">{{ kpi.label }}</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ kpi.value }}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-2x text-gray-300" :class="kpi.icon"></i>
              </div>
            </div>
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <!-- Top hakusanat -->
      <mdb-col md="6" class="mb-4">
        <h6>Top hakusanat</h6>
        <DataTableAG
          :columns="topSearchCols"
          :getcontentpath="gettopsearchpath"
          jsonobject="topsearch"
          :key="componentKey"
          width="1050px"
          height="750px"
        />
      </mdb-col>
      <!-- Kysyntä ilman tarjontaa -->
      <mdb-col md="6" class="mb-4">
        <h6>Kysyntä ilman tarjontaa (Opportunity Score)</h6>
        <DataTableAG
          :columns="opportunityCols"
          :getcontentpath="getopportunitysearchpath"
          jsonobject="opportunities"
          :key="componentKey"
          width="1050px"
          height="750px"
        />
      </mdb-col>
    </mdb-row>
    <!-- Kaupunkianalyysi -->
    <mdb-row>
      <mdb-col md="6" class="mb-4">
        <h6>Kaupunkianalyysi</h6>
        <DataTableAG
          :columns="locationCols"
          :getcontentpath="getlocationsearchpath"
          jsonobject="locationanalysis"
          :key="componentKey"
          width="1050px"
          height="750px"
        />
      </mdb-col>
      <!-- Trendit -->
      <mdb-col md="6" class="mb-4">
        <h6>Nousevat hakusanat</h6>
        <DataTableAG
          :columns="trendCols"
          :getcontentpath="gettrendingsearchpath"
          jsonobject="trendingsearches"
          :key="componentKey"
          width="1050px"
          height="750px"
        />
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer, mdbRow, mdbCol, mdbBtn } from "mdbvue";

export default {
  name: "AISearchAnalyticsDashboard",
  components: { DataTableAG, mdbContainer, mdbRow, mdbCol, mdbBtn },
  data() {
    return {
      days: 30,
      selectedUnionmember: "",
      unionmembers: ["TEHY", "PAM", "JHL", "JYTY", "PRO"],
      summary: null,
      componentKey: 0,
      topSearchCols: [
        {
          field: "query",
          headerName: "Hakusana",
          flex: 2,
          sortable: true,
          filter: true,
        },
        {
          field: "search_count",
          headerName: "Haut",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "unique_customers",
          headerName: "Uniikit",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "avg_results",
          headerName: "Avg tuloksia",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "zero_results",
          headerName: "0-tuloshaut",
          flex: 1,
          sortable: true,
          filter: true,
        },
      ],
      opportunityCols: [
        {
          field: "query",
          headerName: "Hakusana",
          flex: 2,
          sortable: true,
          filter: true,
        },
        {
          field: "location",
          headerName: "Kaupunki",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "unionmember",
          headerName: "Segmentti",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "search_count",
          headerName: "Haut",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "avg_results",
          headerName: "Avg tuloksia",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "opportunity_score",
          headerName: "Opportunity Score",
          flex: 1,
          sortable: true,
          filter: true,
        },
      ],
      locationCols: [
        {
          field: "location",
          headerName: "Kaupunki",
          flex: 2,
          sortable: true,
          filter: true,
        },
        {
          field: "total_searches",
          headerName: "Haut",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "unique_queries",
          headerName: "Eri hakuja",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "top_opportunity_score",
          headerName: "Paras score",
          flex: 1,
          sortable: true,
          filter: true,
        },
      ],
      trendCols: [
        {
          field: "query",
          headerName: "Hakusana",
          flex: 2,
          sortable: true,
          filter: true,
        },
        {
          field: "total_count",
          headerName: "Haut yht.",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "recent_count",
          headerName: "Viimeinen puolisko",
          flex: 1,
          sortable: true,
          filter: true,
        },
        {
          field: "older_count",
          headerName: "Aiempi puolisko",
          flex: 1,
          sortable: true,
          filter: true,
        },
      ],
    };
  },
  computed: {
    queryParams() {
      const p = `days=${this.days}`;
      return this.selectedUnionmember ? `${p}&unionmember=${encodeURIComponent(this.selectedUnionmember)}` : p;
    },
    gettopsearchpath() {
      return `/1.0/front/aisearch/analytics/top-searches?${this.queryParams}`;
    },
    getopportunitysearchpath() {
      return `/1.0/front/aisearch/analytics/opportunities?${this.queryParams}`;
    },
    getlocationsearchpath() {
      return `/1.0/front/aisearch/analytics/location-analysis?${this.queryParams}`;
    },
    gettrendingsearchpath() {
      return `/1.0/front/aisearch/analytics/trending-searches?${this.queryParams}`;
    },
    getsummarypath() {
      return `/1.0/front/aisearch/analytics/dashboard-summary?${this.queryParams}`;
    },
    kpiCards() {
      if (!this.summary) return [];
      return [
        {
          label: "Haut yhteensä",
          value: this.summary.total_searches?.toLocaleString("fi-FI"),
          icon: "fa-search",
          borderClass: "border-left-blue",
          textClass: "text-primary",
        },
        {
          label: "Uniikit hakijat",
          value: this.summary.unique_customers?.toLocaleString("fi-FI"),
          icon: "fa-users",
          borderClass: "border-left-green",
          textClass: "text-success",
        },
        {
          label: "Eri hakusanoja",
          value: this.summary.unique_queries?.toLocaleString("fi-FI"),
          icon: "fa-font",
          borderClass: "border-left-info",
          textClass: "text-info",
        },
        {
          label: "0-tuloshaut",
          value: this.summary.zero_result_searches?.toLocaleString("fi-FI"),
          icon: "fa-exclamation-triangle",
          borderClass: "border-left-warning",
          textClass: "text-warning",
        },
        {
          label: "Paras Opp. Score",
          value: this.summary.top_opportunity_score?.toFixed(1),
          icon: "fa-bullseye",
          borderClass: "border-left-danger",
          textClass: "text-danger",
        },
      ];
    },
  },
  mounted() {
    this.loadSummary();
  },
  methods: {
    setUnionMemberId(val) {
      this.selectedUnionmember = val;
      this.componentKey++;
      this.loadSummary();
    },
    sessionid() {
      return this.$store.getters.getToken;
    },
    params(extra = {}) {
      return {
        sessionid: this.sessionid(),
        days: this.days,
        unionmember: this.selectedUnionmember || undefined,
        ...extra,
      };
    },
    handle401(err) {
      if (err.response?.status === 401) {
        this.$root.$emit("session_failed");
      }
    },
    setDays(d) {
      this.days = d;
      this.componentKey++;
      this.loadSummary();
    },
    loadSummary() {
      this.$http
        .get(this.getsummarypath)
        .then((response) => {
          if (response.status == 200) {
            this.summary = response.data["summary"];
            this.$notify.success({
              message: this.$t("summary_load_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("summary_load_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.text-xs { font-size: .7rem; }
.text-gray-800 { color: #5a5c69; }
.text-gray-300 { color: #dddfeb; }
.border-left-blue { border-left: .25rem solid #4e73df !important; }
.border-left-green { border-left: .25rem solid #1cc88a !important; }
.border-left-info { border-left: .25rem solid #36b9cc !important; }
.border-left-warning { border-left: .25rem solid #f6c23e !important; }
.border-left-danger { border-left: .25rem solid #e74a3b !important; }
</style>
